import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "form",
    show: "loaded"
};
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-details" };
const _hoisted_4 = { class: "form-title" };
const _hoisted_5 = { class: "form-menu" };
const _hoisted_6 = { class: "float-end" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_11 = { class: "form-contents" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_14 = { class: "clearfix" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tCompany *\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_17 = { class: "invalid-feedback" };
const _hoisted_18 = { class: "clearfix" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tName *\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_21 = { class: "invalid-feedback" };
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tRef\r\n\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_24 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_25 = { class: "clearfix" };
const _hoisted_26 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tPhone\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_28 = { class: "invalid-feedback" };
const _hoisted_29 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tEmail\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_31 = { class: "invalid-feedback" };
const _hoisted_32 = { class: "clearfix" };
const _hoisted_33 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tStreet\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_35 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tSuburb\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_37 = { class: "clearfix" };
const _hoisted_38 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tCity / Town\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_40 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tState\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_42 = { class: "clearfix" };
const _hoisted_43 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tCountry\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_45 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tRegion\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_47 = { class: "clearfix" };
const _hoisted_48 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tLatitude\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_50 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tLongitude\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_52 = { class: "clearfix" };
const _hoisted_53 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tContact Group\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h2", {
                        class: _normalizeClass({ 'red-text': _ctx.isSiteArchived })
                    }, _toDisplayString(_ctx.pageTitle || 'Missing site name...'), 3 /* TEXT, CLASS */)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.save
                        }, {
                            default: _withCtx(() => [
                                _hoisted_7,
                                _createTextVNode(" Save\r\n\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _createTextVNode(),
                        _withDirectives(_createVNode(_component_b_button, {
                            type: "button",
                            variant: "danger",
                            onClick: _ctx.archive
                        }, {
                            default: _withCtx(() => [
                                _hoisted_8,
                                _createTextVNode(" Archive\r\n\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]), [
                            [_vShow, !_ctx.isNewSite && !_ctx.isSiteArchived]
                        ]),
                        _createTextVNode(),
                        _withDirectives(_createVNode(_component_b_button, {
                            type: "button",
                            variant: "warning",
                            onClick: _ctx.restore
                        }, {
                            default: _withCtx(() => [
                                _hoisted_9,
                                _createTextVNode(" Restore\r\n\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]), [
                            [_vShow, !_ctx.isNewSite && _ctx.isSiteArchived]
                        ]),
                        _createTextVNode(),
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "secondary",
                            onClick: _ctx.goBack
                        }, {
                            default: _withCtx(() => [
                                _hoisted_10,
                                _createTextVNode(" Close\r\n\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_CollapsibleForm, null, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            return [
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _hoisted_16,
                                        _createTextVNode(),
                                        _createVNode(_component_multiselect, _mergeProps(_ctx.companyIdVal, {
                                            name: "companyId",
                                            modelValue: _ctx.company,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.company) = $event)),
                                            "track-by": "value",
                                            label: "text",
                                            placeholder: _ctx.selectPlaceholder,
                                            options: _ctx.companies,
                                            showLabels: false,
                                            allowEmpty: false,
                                            class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.companyId }
                                        }), {
                                            noResult: _withCtx(() => [
                                                _createTextVNode("No results found")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 16 /* FULL_PROPS */, ["modelValue", "placeholder", "options", "class"]),
                                        _createTextVNode(),
                                        _withDirectives(_createElementVNode("div", _hoisted_17, "\r\n\t\t\t\t\t\t\t\t\t\t* Please select a company.\r\n\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                            [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.companyId]
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _hoisted_20,
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_input, _mergeProps(_ctx.siteNameVal, {
                                            type: "text",
                                            modelValue: _ctx.site.siteName,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.site.siteName) = $event)),
                                            modelModifiers: { trim: true },
                                            name: "siteName",
                                            class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.siteName },
                                            maxlength: "150"
                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                        _createTextVNode(),
                                        _withDirectives(_createElementVNode("div", _hoisted_21, "\r\n\t\t\t\t\t\t\t\t\t\t* Please enter a site name.\r\n\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                            [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.siteName]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_22, [
                                        _hoisted_23,
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_input, {
                                            type: "text",
                                            modelValue: _ctx.site.siteCode,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.site.siteCode) = $event)),
                                            modelModifiers: { trim: true },
                                            maxlength: "50"
                                        }, null, 8 /* PROPS */, ["modelValue"])
                                    ])
                                ]),
                                _createTextVNode(),
                                (_ctx.hasAddress)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("div", _hoisted_26, [
                                                _hoisted_27,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.phoneVal, {
                                                    type: "text",
                                                    modelValue: _ctx.site.address.phone,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.site.address.phone) = $event)),
                                                    name: "phone",
                                                    class: { 'is-invalid': (_e = _ctx.errors) === null || _e === void 0 ? void 0 : _e.phone },
                                                    maxlength: "50"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _createTextVNode(),
                                                _withDirectives(_createElementVNode("div", _hoisted_28, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid phone number.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_f = _ctx.errors) === null || _f === void 0 ? void 0 : _f.phone]
                                                ])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_29, [
                                                _hoisted_30,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.emailVal, {
                                                    type: "text",
                                                    modelValue: _ctx.site.address.emailAddress,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.site.address.emailAddress) = $event)),
                                                    name: "email",
                                                    class: { 'is-invalid': (_g = _ctx.errors) === null || _g === void 0 ? void 0 : _g.email },
                                                    maxlength: "255"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _createTextVNode(),
                                                _withDirectives(_createElementVNode("div", _hoisted_31, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid email.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_h = _ctx.errors) === null || _h === void 0 ? void 0 : _h.email]
                                                ])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_32, [
                                            _createElementVNode("div", _hoisted_33, [
                                                _hoisted_34,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    modelValue: _ctx.site.address.streetAddress1,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.site.address.streetAddress1) = $event)),
                                                    modelModifiers: { trim: true },
                                                    maxlength: "150"
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_35, [
                                                _hoisted_36,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    modelValue: _ctx.site.address.streetAddress2,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.site.address.streetAddress2) = $event)),
                                                    modelModifiers: { trim: true },
                                                    maxlength: "50"
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("div", _hoisted_38, [
                                                _hoisted_39,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    modelValue: _ctx.site.address.streetAddress3,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.site.address.streetAddress3) = $event)),
                                                    modelModifiers: { trim: true },
                                                    maxlength: "50"
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_40, [
                                                _hoisted_41,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    modelValue: _ctx.site.address.streetAddress4,
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.site.address.streetAddress4) = $event)),
                                                    modelModifiers: { trim: true },
                                                    maxlength: "50"
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                                _hoisted_44,
                                                _createTextVNode(),
                                                _createVNode(_component_multiselect, {
                                                    name: "countryId",
                                                    modelValue: _ctx.country,
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.country) = $event)),
                                                    "track-by": "value",
                                                    label: "text",
                                                    placeholder: _ctx.selectPlaceholder,
                                                    options: _ctx.countries,
                                                    showLabels: false
                                                }, {
                                                    noResult: _withCtx(() => [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_45, [
                                                _hoisted_46,
                                                _createTextVNode(),
                                                _createVNode(_component_multiselect, {
                                                    name: "regionId",
                                                    modelValue: _ctx.region,
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.region) = $event)),
                                                    "track-by": "value",
                                                    label: "text",
                                                    placeholder: _ctx.selectPlaceholder,
                                                    options: _ctx.regions,
                                                    showLabels: false
                                                }, {
                                                    noResult: _withCtx(() => [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_47, [
                                            _createElementVNode("div", _hoisted_48, [
                                                _hoisted_49,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    type: "number",
                                                    modelValue: _ctx.site.address.latitude,
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.site.address.latitude) = $event))
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_50, [
                                                _hoisted_51,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    type: "number",
                                                    modelValue: _ctx.site.address.longitude,
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.site.address.longitude) = $event))
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_52, [
                                            _createElementVNode("div", _hoisted_53, [
                                                _hoisted_54,
                                                _createTextVNode(),
                                                _createVNode(_component_multiselect, {
                                                    name: "contactGroupId",
                                                    modelValue: _ctx.contactGroup,
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.contactGroup) = $event)),
                                                    "track-by": "value",
                                                    label: "text",
                                                    placeholder: _ctx.selectPlaceholder,
                                                    options: _ctx.contactGroups,
                                                    showLabels: false
                                                }, {
                                                    noResult: _withCtx(() => [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ])
            ])
        ])
    ]));
}
